module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.6912/img/storefront-header-blobs.svg"